import { render } from "./AddGroupInfo.vue?vue&type=template&id=1844c741&scoped=true&ts=true"
import script from "./AddGroupInfo.vue?vue&type=script&lang=ts"
export * from "./AddGroupInfo.vue?vue&type=script&lang=ts"

import "./AddGroupInfo.vue?vue&type=style&index=0&id=1844c741&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1844c741"]])

export default __exports__